import { Box, Card, Grid, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";
import { KeyDrivePrimaryButton } from "../../KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import { KeyDriveBodyMin } from "../../KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { useLocation, useNavigate } from "react-router-dom";
import { AddLastUrlPathLocalStorage } from "../../../pages/PublicLayout/RedirectManager";

export const MiniCardNoWorkspaceAdmin = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Card
            elevation={0}
            sx={{
                border: "1px solid #0000001A",
                borderRadius: "3px",
                position: "relative",
                display: "flex",
                alignItems: "center",
                padding: "18px",
                height: "62px"
            }}
        >
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >   
                <Box>
                    <Typography
                        textAlign="left"
                        fontSize="14px"
                        fontWeight="600"
                        sx={{
                            opacity: 1
                        }}
                    >
                        {t("Minicard.NothingViewMiniCardWorkspaceTitleAdm")}
                    </Typography>
                    <Typography
                        textAlign="left"
                        fontSize="14px"
                        sx={{
                            opacity: .6
                        }}
                    >
                        {t("Minicard.NothingViewMiniCardWorkspaceContentAdm")}
                    </Typography>
                </Box>
                <Box
                    ml="20px"
                >
                    <KeyDrivePrimaryButton 
                        TextComponent={KeyDriveBodyMin}
                        TextComponentProps={{
                            color: "",
                            needBold: false,
                            needEllipses: false,
                            text: t("AdminConsole.CreateWorkspace")
                        }}
                        onClick={() => {
                            AddLastUrlPathLocalStorage(location.pathname);
                            navigate(`adminConsole/workspaces/config`);
                        }}
                    />
                </Box>
            </Box>
        </Card>
    )
}